module.exports = __webpack_public_path__ + "img/erp_tab03_img_l.14cdfd6c.png";